import { render } from "./IngresosCobro.vue?vue&type=template&id=7bbaf1ef"
import script from "./IngresosCobro.vue?vue&type=script&lang=js"
export * from "./IngresosCobro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ingresos/IngresosCobro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bbaf1ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bbaf1ef', __exports__)) {
    api.reload('7bbaf1ef', __exports__)
  }
  
  module.hot.accept("./IngresosCobro.vue?vue&type=template&id=7bbaf1ef", () => {
    api.rerender('7bbaf1ef', render)
  })

}


export default __exports__